<!--
 * @Descripttion: 过滤条件弹窗
 * @Author: zenghua.wang
 * @Date: 2021-06-07 14:11:30
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-03-29 18:06:50
-->
<template>
  <el-dialog
    :title="dialog.title"
    :visible.sync="dialog.show"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    append-to-body
    width="70%"
    class="dialog"
  >
    <el-form
      ref="form"
      size="small"
      :model="form"
      label-width="120px"
      label-suffix=":"
      v-loading="filterLoading"
      :element-loading-text="component.loadingText"
      :element-loading-spinner="component.loadingSpinner"
      :element-loading-background="component.loadingBackground"
    >
      <el-form-item
        label="组件关联"
        v-if="category == 'report'"
      >
      <!-- v-if="category == 'report' && main.vaildProp(data.option, 'conditionId')" -->
        <el-select
          v-model="data.option.conditionId"
          size="small"
          clearable
          placeholder="请选择"
          @change="onChangeWidget"
        >
          <el-option
            v-for="item in widgets"
            :key="item.value"
            :label="item.label"
            :disabled="item.disabled"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="参数列表">
        <el-table
          size="small"
          style="width: 100%; margin-bottom: 20px"
          fit
          :data="list"
          border
        >
          <el-table-column label="参数名">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.prop"
                style="width:100%"
                size="small"
                clearable
                filterable
                allow-create
                default-first-option
                :popper-append-to-body="false"
                placeholder="请选择"
                @change="setFormProp($event, scope.row)"
              >
                <el-option
                  v-for="feild in main.apiFieldList"
                  :key="feild.value"
                  :label="feild.label"
                  :value="feild.label"
                  :disabled="feild.disabled"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="参数中文名">
            <template slot-scope="scope">
              <el-input
                size="small"
                v-model="scope.row.label"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="条件类型">
            <template slot-scope="scope">
              <el-select
                style="width:100%"
                v-model="scope.row.conditionType"
                size="small"
                clearable
                placeholder="请选择"
                @change="onChangeCondition($event, scope.row)"
              >
                <el-option
                  v-for="item in conditonType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="参数值">
            <template slot-scope="scope">
              <el-select
                style="width:100%"
                v-if="scope.row.conditionType == '1'"
                v-model="scope.row.key"
                size="small"
                clearable
                filterable
                placeholder="请选择"
                @change="onChangeLocalStorage($event, scope.row)"
              >
                <el-option
                  v-for="item in localStorage"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                ></el-option>
              </el-select>

              <el-select
                style="width:100%"
                v-else-if="scope.row.conditionType == '3'"
                v-model="scope.row.key"
                size="small"
                clearable
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in conditionList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                ></el-option>
              </el-select>

              <!-- <el-select
                v-else-if="scope.row.conditionType == '4'"
                v-model="scope.row.key"
                size="small"
                clearable
                filterable
                placeholder="请选择"
                @change="onChangeParams($event, scope.row)"
              >
                <el-option
                  v-for="item in params"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                ></el-option>
              </el-select> -->

              <!-- 外部条件 -->
              <el-input
                v-else-if="scope.row.conditionType == '4'"
                size="small"
                v-model="scope.row.key"
                placeholder="请输入"
              ></el-input>

              <!-- 固定值 -->
              <el-input
                v-else
                size="small"
                v-model="scope.row.value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="deleteColumn(scope.$index)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="addColumn"
        >新增</el-button>
      </el-form-item>
    </el-form>

    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        size="small"
        @click="dialog.show = false"
      >取 消</el-button>
      <el-button
        size="small"
        type="primary"
        @click="onSubmit"
      >确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { component } from '@/dragComponents/model/default.js'
import { getStore } from '@/framework/util/store'
import { isEmpty } from '@/dragComponents/utils'

export default {
  name: 'config-filter-dialog',
  inject: ['main', 'category'],
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    dialog: {
      type: Object,
      default: () => {
        return {}
      }
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    column: {
      type: [Object, Array]
    },
    // 所有的搜索组件
    widgets: {
      type: Array,
      default: () => {
        return []
      }
    },
    // url获取参数
    params: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      component: component,
      list: this.column,
      localStorage: [
        {
          label: '姓名',
          value: 'name'
        },
        {
          label: '工号',
          value: 'idCard'
        },
        {
          label: 'id',
          value: 'id'
        }
      ],
      conditionList: []
      // paramsList: []
    }
  },
  watch: {
    column(val) {
      this.list = val
    },
    list: {
      handler(val) {
        this.$emit('update:column', val)
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    conditonType() {
      let conditions = [
        {
          label: '登录人',
          value: '1'
        },
        {
          label: '固定值',
          value: '2'
        },
        {
          label: '关联',
          value: '3'
        },
        {
          label: '外部条件',
          value: '4'
        }
      ]
      if (this.category === 'screen') {
        conditions = conditions.filter((item) => {
          return item.value === '2' || item.value === '4'
        })
      }
      return conditions
    }
  },
  methods: {
    // 选择字段
    setFormProp(e, row) {
      if (isEmpty(e)) return
      let label = isEmpty(e.label) ? e : e.label
      if (isEmpty(e.label)) {
        this.$nextTick(() => {
          row.prop = label
        })
      } else {
        row.prop = label
      }
    },
    onChangeWidget(val) {
      this.widgets.forEach((item) => {
        if (item.value === val) {
          this.conditionList = item.list
        }
      })
      // 搜索组件保存关联组件id
      this.main.data.list.forEach((widget) => {
        if (widget.prop === val) {
          if (!widget.option.relationship.includes(this.data.prop)) {
            widget.option.relationship.push(this.data.prop)
          }
        }
      })
      console.log(354, this.widgets, val, this.data.prop)
    },
    onChangeCondition(type, row) {
      // console.log("type==", type, row, this.widgets, this.params);
      switch (type) {
        case '3':
          this.widgets.forEach((item) => {
            if (item.value === this.data.option.conditionId) {
              this.conditionList = item.list
            }
          })
          break
        default:
      }
      row.key = ''
      row.value = ''
    },
    // 登录人通过选择的key转化为value去搜索
    onChangeLocalStorage(key, row) {
      let userInfo = getStore({ name: 'userInfo' })?.subject
      this.localStorage.forEach((item) => {
        if (item.label === key) {
          row.value = userInfo[item.value] || null
        }
      })
    },
    addColumn() {
      this.filterColumn()
      this.list.push({
        label: '',
        prop: '',
        key: '',
        value: '',
        conditionType: ''
      })
    },
    deleteColumn(index) {
      this.list.splice(index, 1)
    },
    filterColumn() {
      this.list = this.list.filter((item) => {
        return item.prop || item.conditionType
      })
    },
    onSubmit() {
      this.filterColumn()
      this.$emit('change', this.list)
      this.dialog.show = false
    }
  }
}
</script>
